import React, {PureComponent} from "react"
import {H4, Body} from "@irati/ui/src/Typography"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Spacing from "@irati/ui/src/Spacing"

import {BackgroundColor, Image, Link} from "./styled"

interface Props extends InjectIntl {
  id?: string,
  title: string,
  link: string,
  text: string,
  image: string,
  color?: string,
  onClick?: () => void
}

class Tile extends PureComponent<Props> {
  handleClick= () => {
    const {onClick} = this.props
    if(onClick) {
      onClick()
    }
  }

  render() {
    const {title, link, text, image, color, formatMessage} = this.props
    return (
      <>
        <BackgroundColor color={color} padding={[4, 0]}>
          <Image src={image} width="160" color={color} />
        </BackgroundColor>
        <Spacing padding={[4, 4, 2, 2]}>
          <Link
            href={formatMessage({id: link})}
            id="adminSection__dashboard_resourceHubLink"
            target="_blank"
            onClick={this.handleClick}>
            <H4 marginBottom={1} display="inline-block">
              <FormattedMessage id={title} />
            </H4>
            <Icon icon={IconTypes.arrowRight} marginLeft={1} small />
          </Link>
          <Body>
            <FormattedMessage id={text} />
          </Body>
        </Spacing>
      </>
    )
  }
}

export default injectIntl(Tile)
